import EventEmitter from 'events';

export default class Resizer extends EventEmitter {
  constructor(element, minHeight) {
    super();

    this._active = false;
    this._el = element;
    this._minHeight = minHeight;

    this._el.classList.add('resizer');

    this._handle = document.createElement('DIV');
    this._handle.setAttribute('class', 'resizer-handle');

    this._el.appendChild(this._handle);

    this._mouseUpListener = this._mouseUp.bind(this);
    this._mouseMoveListener = this._mouseMove.bind(this);

    this._handle.addEventListener('mousedown', e => {
      if (e.target !== this._handle) {
        return;
      }

      this._active = true;

      window.addEventListener('mouseup', this._mouseUpListener);
      window.addEventListener('mousemove', this._mouseMoveListener);
    });
  }

  _mouseUp(e) {
    this._active = false;

    window.removeEventListener('mouseup', this._mouseUpListener);
    window.removeEventListener('mousemove', this._mouseMoveListener);
  }

  _mouseMove(e) {
    if (!this._active) {
      return false;
    }

    const top = this._el.offsetTop,
        height = this._el.offsetHeight,
        dy = e.clientY - (top + height),
        newHeight = height + dy;

    if (newHeight >= this._minHeight) {
      this._el.style.height = newHeight + 'px';
      this.emit('resize', newHeight);
    }

    e.preventDefault();

    return false;
  }
}
